Pre-set
<template >
  <div>
    <div
      v-if="openEmailsCountRelayBox"
      class="floating-signals-table-email-count-relay"
    >
      <vue-editor
        :editorOptions="editorSettings"
        v-model="emailTextFromLocal"
      />

      <buttons
        class="bttns pull-right"
        @click="
          [
            sendEmails(emailTextFromLocal, client),
            (openEmailsCountRelayBox = false),
            (emailTextFromLocal = '')
          ]
        "
        >Send</buttons
      >
      <buttons
        class="bttns pull-right"
        @click="[(openEmailsCountRelayBox = false), (emailTextFromLocal = '')]"
        >Cancel</buttons
      >
    </div>

    <div   v-if="openEmailsCountRelayBox"  class="floating-signals-table-email-count-relay-for-re-from-email">
      <h2>Replay :</h2>
      <hr>
      <div v-html="getReEmailContent()"></div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { VueEditor, Quill } from "vue2-editor";
import { mapState, mapGetters, mapActions } from "vuex";
import apiClientCreator from "../../../../../helpers/api/request";
import { Globals } from "../../../../../global_constants/constants";

export default {
  name: "EmailsReply",
  props: {
    client: {
      type: Object
    },
    openEmailsCountRelayBox: {
      type: Boolean
    }
  },
  components: {
    VueEditor
  },

  data() {
    return {
      emailTextFromLocal: "",
      tempClientLog: "",
      showEmailsLogTable: false,
      editorSettings: {
        modules: {
          imageResize: { displaySize: true }
        }
      }
    };
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapGetters("user", ["isLogged"]),
    ...mapState("clients", ["dictionaries"]),
    ...mapGetters("main", ["showVikiMsg"]),
    ...mapState("main", ["showVikiMsg"])
  },
  mounted() {
    // console.log(this.client.email_replays);
    this.tempClientLog = this.client.email_log;
    // console.log(this.client.email_log);
  },
  methods: {
    getReEmailContent(){

      if(this.client.email_replays.length > 0){
       if(this.client.email_replays[0].task){
         let text = this.client.email_replays[0].task.content;
         text =text.replace('On', '.\n On Date: ')
         if(text.includes("PM")){
           text = text.split("PM")[0];
         }else if(text.includes("AM")){
           text = text.split("AM")[0];
         }
       return text;
        }
      }
    },
    sendEmails(emailinfo, client) {
      // console.log(emailinfo, client);
      this.removeHtmlAndSend(emailinfo, client);
    },

    async removeHtmlAndSend(tag, client) {
      let temp = await tag.replace(/<\/?[^>]+(>|$)/g, " ");
      const sendEmailReply = apiClientCreator(`client/email/send/${client.id}`);
      sendEmailReply
        .post("", {
          tag: temp,
          client: client,
          email: client.emails[0].contact_value,
          clientFullName: client.full_name,
          fName: client.first_name,
          lName: client.last_name,
          presetId:10 //raw-emails-pingPong//
        })
        .then(a => {
          // console.log(a+'hello');
        });
    },
    cancelEmailReplayBox() {
      this.openEmailReplayBox = false;
    }
  }
};
</script>

<style scoped>
.clickAble {
  cursor: pointer;
  /*margin-left: 4%;*/
}
.floating-wrapper-span {
  position: absolute;
  top: 0px;
  right: -10px;
}
.floating-wrapper {
  position: absolute;
  top: 3px;
  right: 162px;

  font-size: 10pt;
}
.calls-length {
  font-size: 9pt;
  color: #0d6aad;
  cursor: pointer;
  width: 11px;
  text-align-last: end;
}

/*.floating-signals-table-email-feedbacks {*/
/*  position: absolute;*/
/*  top: 50px;*/
/*  left: -175px;*/
/*  padding-right: 54px;*/
/*  width: 415px;*/
/*  z-index: 10001;*/
/*  border: solid 1px #ccc;*/
/*  padding: 10px;*/
/*  background-color: #fff;*/
/*  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);*/
/*  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);*/
/*  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);*/
/*}*/
/*.floating-signals-table-email-feedbacks ul li {*/
/*  list-style-type: none;*/
/*  padding: 5px;*/
/*}*/
.bttns {
  font-family: Montserrat !important;
  width: fit-content;
  margin-top: 0.5rem;
  margin-left: 1rem;
  background: #44a2d2;
  color: white;
  border: 0;
  border-radius: inherit;
  padding: 5px;
  font-size: 10px;
  /*font-family: inherit;*/
  cursor: pointer;
}
.cancel-edit-menu-item-EmailReplayBox {
  padding: 5px;
  color: #f44336;
  font-weight: bold;
  position: absolute;
  top: 47px;
  left: 133px;
  cursor: pointer;
}
.floating-signals-table-email-count-relay-for-re-from-email{
  position: absolute;
  top: 34px;
  left: 239px;
  /* right: 9px; */
  height: 334px;
  width: 445px;
  z-index: 10001;
  border: solid 1px  #ccc !important;
  padding: 10px;
  background-color: #fff;
  /* -webkit-box-shadow: 4px 4px 11px -4px rgb(0 0 0 / 75%); */
  box-shadow: 4px 4px 11px -9px rgb(0 0 0 / 75%);
}
.floating-signals-table-email-count-relay {
  position: absolute;
  top: 32px;
  /*left: 254px;*/
  right: 0;
  width: 445px;
  z-index: 10001;
  border: solid 1px #ccc;
  padding: 10px;
  background-color: #fff;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}
.table-responsive {
  margin-bottom: -18px;
  border-radius: 5px;
}
.tag-table {
  position: absolute;
  top: 24px;
  left: -20px;
  z-index: 10001;
  background-color: #fff;
  width: max-content;
  height: 200px;
  overflow-y: scroll;
  border: solid 1px #90a4ae;
  border-radius: 5px;
  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}
.dash {
  position: absolute;
  top: 2px;
  left: -10px;
  font-size: 9pt;
  color: #0d6aad;
  cursor: pointer;
}
</style>
